import * as _ from "lodash";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./index.scss";
import { useTranslation } from "react-i18next";
import {
  addProfileAppearance,
  editProfileAppearance,
} from "../../../../../../store/profile-appearance/thunkAction";
import {
  DateFormat,
  MessageStyle,
  TimeFormat,
} from "../../../../../../constant/enums";
import Dropdown from "../../../../../../components/core/dropdown";
import { editProfile } from "../../../../../../store/profile/thunkAction";
import {
  sendNotifyIziMessageError,
  sendNotifyIziMessageSuccess,
} from "../../../../../../utils/event";

const AppearanceContent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const profileId = _.get(params, "id");

  const [minimizeHeader, setMinimizeHeader] = useState("");
  const [progressChat, setProgressChat] = useState("");
  const [startChat, setStartChat] = useState("");
  const [blockedChat, setBlockedChat] = useState("");
  const [outsideWorkingChat, setOutsideWorkingChat] = useState("");
  const [timeZone, setTimeZone] = useState(null);
  const [timeFormat, setTimeFormat] = useState(TimeFormat.FORMAT_12H);
  const [dateFormat, setDateFormat] = useState(DateFormat.DD_MM_YYYY);
  const [messageStyle, setMessageStyle] = useState(MessageStyle.SPEECH_BUBBLES);

  const profileAppearanceManage = useSelector(
    (state) => state.profileAppearanceManage
  );
  const profileManage = useSelector((state) => state.profileManage);
  const profileAppearance = _.get(profileAppearanceManage, "profileAppearance");

  const timeZones = _.get(profileManage, "timeZones");
  const isLoadingProfileAppearance = _.get(
    profileAppearance,
    "isLoadingProfileAppearance",
    false
  );
  const profileAppearanceId = _.get(profileAppearance, "_id");

  useEffect(() => {
    const content = _.get(profileAppearance, "content", {});
    setMinimizeHeader(_.get(content, "minimizeHeader", ""));
    setProgressChat(_.get(content, "progressChat", ""));
    setStartChat(_.get(content, "startChat", ""));
    setBlockedChat(_.get(content, "blockedChat", ""));
    setOutsideWorkingChat(_.get(content, "outsideWorkingChat", ""));
    setTimeZone(_.get(content, "timeZone", null));
    setTimeFormat(_.get(content, "timeFormat", TimeFormat.FORMAT_12H));
    setDateFormat(_.get(content, "dateFormat", DateFormat.DD_MM_YYYY));
    setMessageStyle(
      _.get(content, "messageStyle", MessageStyle.SPEECH_BUBBLES)
    );
  }, [profileAppearance]);

  const onSelectTimeZone = (option) => {
    setTimeZone(option?.value || null);
  };

  const mapTimeZone = {
    id: "value",
    name: "text",
  };

  const saveContent = async () => {
    const content = {
      minimizeHeader,
      progressChat,
      startChat,
      blockedChat,
      outsideWorkingChat,
      timeZone,
      timeFormat,
      dateFormat,
      messageStyle,
    };

    try {
      dispatch(editProfile({ id: profileId, data: { timeZone: timeZone } }));

      if (profileAppearanceId) {
        await dispatch(
          editProfileAppearance({
            id: profileAppearanceId,
            data: {
              content,
            },
            isFormData: false,
          })
        ).unwrap();

        sendNotifyIziMessageSuccess(
          t("profile.profile_appearance_save_success")
        );

        return;
      }

      const data = {
        profileId,
        window: {},
        chatBadge: {},
        content,
      };

      if (isLoadingProfileAppearance) {
        return;
      }

      await dispatch(
        addProfileAppearance({ data, isFormData: false })
      ).unwrap();
      sendNotifyIziMessageSuccess(t("profile.profile_appearance_save_success"));
    } catch (error) {
      const errorCode = _.get(error, "errorCode");
      if (errorCode === "FILE_NOT_ALLOWED") {
        sendNotifyIziMessageError(t("profile.upload_file_error"));
      } else if (errorCode === "FILE_TOO_LARGE") {
        sendNotifyIziMessageError(t("profile.file_too_large"));
      } else {
        sendNotifyIziMessageError(t("profile.profile_appearance_save_error"));
      }
    }
  };

  return (
    <div
      className="tab-pane fade active show"
      id="content-tab-pane"
      role="tabpanel"
      aria-labelledby="content-tab"
      tabIndex="0"
    >
      <div className="row">
        <div className="col-lg-3">
          <h5 className="title">
            {t("settings.profile.profile_appearance.chat_status")}
          </h5>
        </div>
        <div className="col-lg-7">
          <div className="row g-4">
            <div className="col-12">
              <label className="form-label text-uppercase">
                {t("settings.profile.profile_appearance.minimize_header")}
              </label>
              <input
                className="form-control"
                value={minimizeHeader}
                onChange={(e) => setMinimizeHeader(e.target.value)}
              />
            </div>
            <div className="col-12">
              <label className="form-label text-uppercase">
                {t("settings.profile.profile_appearance.chat_in_progress")}
              </label>
              <input
                className="form-control"
                value={progressChat}
                onChange={(e) => setProgressChat(e.target.value)}
              />
            </div>
            <div className="col-12">
              <label className="form-label text-uppercase">
                {t("settings.profile.profile_appearance.start_chat")}
              </label>
              <input
                className="form-control"
                value={startChat}
                onChange={(e) => setStartChat(e.target.value)}
              />
            </div>
            <div className="col-12">
              <label className="form-label text-uppercase">
                {t("settings.profile.profile_appearance.blocked_chat")}
              </label>
              <input
                className="form-control"
                value={blockedChat}
                onChange={(e) => setBlockedChat(e.target.value)}
              />
            </div>
            <div className="col-12">
              <label className="form-label text-uppercase">
                {t("settings.profile.profile_appearance.outside_working_chat")}
              </label>
              <input
                className="form-control"
                value={outsideWorkingChat}
                onChange={(e) => setOutsideWorkingChat(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
      <hr className="mb-4 mt-4" />
      <div className="row mb-5">
        <div className="col-lg-3">
          <h5 className="title">
            {t("settings.profile.profile_appearance.content")}
          </h5>
        </div>
        <div className="col-lg-7">
          <div className="row g-4">
            <div className="col-12">
              <label className="form-label text-uppercase">
                {t("settings.profile.profile_appearance.date_format")}
              </label>
              <div className="d-flex align-items-center btn-tab-box">
                <button
                  className={
                    dateFormat === DateFormat.DD_MM_YYYY
                      ? "btn btn-gray-light btn-tab active rounded-0 rounded-start"
                      : "btn btn-gray-light btn-tab rounded-0 rounded-start"
                  }
                  onClick={() => setDateFormat(DateFormat.DD_MM_YYYY)}
                >
                  dd/mm/yyyy
                  <span className="color-success">●</span>
                </button>

                <button
                  className={
                    dateFormat === DateFormat.MM_DD_YYYY
                      ? "btn btn-gray-light btn-tab active rounded-0 rounded-end"
                      : "btn btn-gray-light btn-tab rounded-0 rounded-end"
                  }
                  onClick={() => setDateFormat(DateFormat.MM_DD_YYYY)}
                >
                  mm/dd/yyyy
                  <span className="color-success">●</span>
                </button>
              </div>
            </div>
            <div className="col-12">
              <label className="form-label text-uppercase">
                {t("settings.profile.profile_appearance.time_format")}
              </label>
              <div className="d-flex align-items-center btn-tab-box">
                <button
                  className={
                    timeFormat === TimeFormat.FORMAT_12H
                      ? "btn btn-gray-light btn-tab active rounded-0 rounded-start"
                      : "btn btn-gray-light btn-tab rounded-0 rounded-start"
                  }
                  onClick={() => setTimeFormat(TimeFormat.FORMAT_12H)}
                >
                  {t("settings.profile.profile_appearance.12h_clock")}
                  <span className="color-success">●</span>
                </button>

                <button
                  className={
                    timeFormat === TimeFormat.FORMAT_24H
                      ? "btn btn-gray-light btn-tab active rounded-0 rounded-end"
                      : "btn btn-gray-light btn-tab rounded-0 rounded-end"
                  }
                  onClick={() => setTimeFormat(TimeFormat.FORMAT_24H)}
                >
                  {t("settings.profile.profile_appearance.24h_clock")}
                  <span className="color-success">●</span>
                </button>
              </div>
            </div>
            <div className="col-12">
              <Dropdown
                config={{
                  options: timeZones,
                  onSelect: onSelectTimeZone,
                  placeholder: t(
                    "settings.profile.profile_appearance.time_zone"
                  ),
                  map: mapTimeZone,
                  value: timeZone,
                  stylePopup: {
                    maxHeight: "200px",
                  },
                }}
              />
            </div>
            <div className="col-12">
              <label className="form-label text-uppercase">
                {t("settings.profile.profile_appearance.message_style")}
              </label>
              <div className="d-flex align-items-center btn-tab-box">
                <button
                  className={
                    messageStyle === MessageStyle.SPEECH_BUBBLES
                      ? "btn btn-gray-light btn-tab active rounded-0 rounded-start"
                      : "btn btn-gray-light btn-tab rounded-0 rounded-start"
                  }
                  onClick={() => setMessageStyle(MessageStyle.SPEECH_BUBBLES)}
                >
                  {t("settings.profile.profile_appearance.speech_bubbles")}
                  <span className="color-success">●</span>
                </button>

                <button
                  className={
                    messageStyle === MessageStyle.SIMPLE_LINES
                      ? "btn btn-gray-light btn-tab active rounded-0 rounded-end"
                      : "btn btn-gray-light btn-tab rounded-0 rounded-end"
                  }
                  onClick={() => setMessageStyle(MessageStyle.SIMPLE_LINES)}
                >
                  {t("settings.profile.profile_appearance.simple_lines")}
                  <span className="color-success">●</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card-footer">
        <div className="d-flex gap-3 justify-content-center align-items-center">
          <button onClick={saveContent} className="btn btn-primary">
            {t("common.save")}
          </button>
          <button
            onClick={() => {
              navigate(`/profile/${profileId}/detail`);
            }}
            className="btn btn-gray btn-outline-gray"
          >
            {t("common.exit")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppearanceContent;
